import script from "./company-table.vue?vue&type=script&setup=true&lang=js"
export * from "./company-table.vue?vue&type=script&setup=true&lang=js"

import "./company-table.vue?vue&type=style&index=0&id=a1c5e67c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1c5e67c"]])

export default __exports__